import { connect } from "react-redux";
import SignOutScreen from "./SignOutScreen";
import { authOperations } from "../../redux/operations/authOperations";

function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch(authOperations.logout()),
  };
}

const connectedSignOutScreen = connect(null, mapDispatchToProps)(SignOutScreen);
export default connectedSignOutScreen;
